var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import UpsellItemModel from './UpsellItemModel';
import { filter, forEach, includes } from 'lodash';
var UpsellRuleModel = /** @class */ (function (_super) {
    __extends(UpsellRuleModel, _super);
    function UpsellRuleModel(data) {
        var _this = _super.call(this, data) || this;
        delete _this.name;
        _this.id = data.rule_id;
        _this.items = [];
        forEach(data.items, function (item) {
            var upsellItem = new UpsellItemModel(item);
            _this.items.push(upsellItem);
        });
        _this.optionId = data.option_id;
        _this.choiceId = data.choice_id;
        _this.targetChoiceId = data.target_choice_id;
        _this.mobileMessage = data.mobile_message;
        _this.attempts = data.attempts;
        _this.conversions = data.conversions;
        return _this;
    }
    UpsellRuleModel.prototype.hasItem = function (itemIds) {
        var filteredItems = [];
        filteredItems = filter(this.items, function (item) {
            return (includes(itemIds, item.assetId));
        });
        if (filteredItems.length > 0) {
            return true;
        }
        return false;
    };
    UpsellRuleModel.prototype.getItemTargetDiscount = function (itemIds) {
        var filteredItems = filter(this.items, function (item) {
            return (includes(itemIds, item.assetId));
        });
        var firstItem = filteredItems.shift();
        var amount = firstItem.targetPriceDelta;
        return amount;
    };
    return UpsellRuleModel;
}(BaseModel));
export { UpsellRuleModel };



//////////////////
// WEBPACK FOOTER
// ./src/models/UpsellRuleModel.ts
// module id = null
// module chunks = 